// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x6Be","actions":"styles_actions__1eNLf","error":"styles_error__6ZxkD","message":"styles_message__3lc0z"};